module.exports = __webpack_public_path__ + "img/af.7af5f190.svg";